// <template>
// 	<div>
// 		<el-drawer :visible.sync="drawer_model" :size="drawer_size" :title="drawer_title" :width="drawer_width" @opened="drawer_onshow" @closed="drawer_onhide">

// 		</el-drawer>
// 	</div>
// </template>
// <style scoped>

// </style>

export default {
	props: {

	},
	data() {
		return {
			login_needloginpage: ['indexmodule', 'add', 'update', 'preview', 'report', 'penetrate','custompage'],
			login_status: 0,
			login_routerMoudle: [{
				path: '/main',
				name: 'main',
				component: () => import('@_system/views/main/index'),
				children: []
			}],
			login_sourcedata: null,
			login_device: window.systemMethods.device()
		}
	},
	created() {

	},
	methods: {
		login_init() {
			this.login_isLogin()
		},
		login_toLoginpage() {
			let obj = {
				name: 'login'
			}
			if (this.login_checkSinglePage()) {
				obj.query = {
					redirect_uri: window.location.href
				}
			}
			this.$router.push(obj)

		},
		login_isLogin() {
			if(window.localStorage.getItem(this.$store.state.logincompany)){
				window.config.company = window.localStorage.getItem(this.$store.state.logincompany)
				let obj = window.config.logincompany.find((item)=>{
					return item.id == window.config.company
				})
				if(obj){
					window.config = {...window.config,...obj}
				}
			}
			
			let token = window.localStorage.getItem(this.$store.state.token)
			this.$api.isLogin({
				token: token
			}).then((res) => {
				if (res.res == 1) {
					this.$store.commit('system/setSystemdata', res.systemdata)
					this.$store.commit('system/setUser', res.user)
					this.$store.commit('system/setAppshow', true)
					this.login_handle(res)

				} else {
					this.unlogin_handle()
				}
			}, () => {
				this.unlogin_handle()
			})
		},
		login_handle() {
			this.login_status = 1
			this.$store.commit('system/initSystemdata')
			if (!this.login_checkSinglePage()) {
				this.$store.commit('system/setAppshow', true)
				this.$store.commit('system/setFormshow', false)
				this.login_getNavItem()
				this.socketShow = true
				// if (this.device == 'pc') {
				// 	this.embedChatbot()
				// }
			} else {
				this.$store.commit('system/setAppshow', false)
				this.$store.commit('system/setFormshow', true)
				//this.login_getNavItem()
			}
			this.login_after()
		},
		login_after() {

		},
		login_tomainpage(){
			let url = new URL(window.location.href)
			window.location.href = url.origin +'/'+window.config.project
		},
		unlogin_handle() {
			window.localStorage.removeItem(this.$store.state.token)
			window.localStorage.removeItem(this.$store.state.logincompany)
			this.$store.commit('system/setAppshow', true)
			if (this.$router.currentRoute.path != '/login') {
				this.login_toLoginpage()
				//this.$router.push('/login')
			}
		},

		login_checkSinglePage() {
			let buff = false
			this.login_needloginpage.forEach((item) => {
				if (window.location.href.indexOf('#/' + item) !== -1) {
					buff = true
				}
			})
			return buff
		},
		login_getNavItem() {
			let currentRoute = this.$router.currentRoute.path
			if (this.NavItemInit) {
				if (this.device != 'pc') {
					this.$router.push('/main/cooperate/matter/index')
				} else {
					this.$router.push('/main/cooperate/index')
				}
				return
			}
		
			return this.$api.module.list().then((res) => {
				this.NavItemInit = true
				let baseRouter = this.login_getBaseModuleRoute()

				res.list.forEach((item) => {
					item.children = []
					res.list.forEach((_item) => {
						if (item.id == _item.parentid) {
							item.children.push(_item)
						}
					})
				})
				//console.log(res.list)
				let moduleMap = {}
				res.list.forEach((item) => {
					if (item.component) {
						moduleMap[item.controller] = item.component
					}
					//console.log(item.default)
					let component = ''
					if (item.parentid === 0) {
						if (item.type == 'system') {
							component = () => import(`@_system/${item.component}`)
						} else {
							component = () => import(`@/${item.component}`)
						}
						let routerItem = {
							order: item.order,
							no: item.id,
							path: '/main/' + item.component.split('/main/')[1],
							name: item.name,
							component: component,
							controller: item.controller,
							type: item.type,
							meta: {								
								group: item.group,
								id: item.id,
								timeStamp: Math.random(),
								toolbarbutton: item.toolbarbutton,
								operatebutton: item.operatebutton,
								children: item.children,
							},
						}
						baseRouter.push(routerItem)
						if (item.default) {
							this.defalutRoute = routerItem
						}
					}
				})
				
				this.$store.commit('setModuleMap', moduleMap)
				//console.log(this.$store.state)
				//=================================

				this.login_routerMoudle[0].children = baseRouter
				if (this.login_routerMoudle[0].children.length == 0) {
					window.localStorage.removeItem(this.$store.state.token)
					window.localStorage.removeItem(this.$store.state.logincompany)
					this.$message.error('您没有任何模块权限')
				} else {
					
					//alert(123)
					this.$router.options.routes = this.$router.options.routes.concat(this.login_routerMoudle)
					this.$router.addRoutes(this.login_routerMoudle)
					let currentRouteReslove = this.$router.resolve(currentRoute)
					//console.log(currentRouteReslove)
					//alert(JSON.stringify(currentRouteReslove))
					if (currentRouteReslove.route.matched.length) {
						if (currentRoute === '/login') {
							if (this.device != 'pc') {
								this.$router.push('/main/cooperate/matter/index')
							} else {
								this.$router.push('/main/cooperate/index')
							}
						}
					} else {
						if (this.login_status == 1) {
							if (this.login_checkSinglePage()) {
								window.location.reload()
							} else {
								if (this.device != 'pc') {
									this.$router.push('/main/cooperate/matter/index')
								} else {
									this.$router.push('/main/cooperate/index')
								}
							}
						} else {
							this.login_toLoginpage()
						}

					}
				}
			})
		},

		
		login_getBaseModuleRoute() {
			let datacenter = window.config.systemmodule.find((item) => {
				return item == 'datacenter'
			})
			let cooperate = window.config.systemmodule.find((item) => {
				return item == 'cooperate'
			})

			let router = []
			if (this.device != 'pc') {
				if (cooperate) {
					router.push({
						no: 0,
						path: '/main/cooperate/matter/index',
						name: '待办事项',
						type: 'system',
						component: () => import('@_system/views/main/cooperate/matter/index.vue'),
						meta: {
							id: 0,
							activeName: 'matter',
							timeStamp: Math.random(),
							toolbarbutton: null,
							operatebutton: null,
							children: [],
						},
					})
				}
				if (datacenter) {
					router.push({
						no: 0,
						path: '/main/datacenter/index',
						name: '数据概览',
						type: 'system',
						component: () => import('@_system/views/main/datacenter/index.vue'),
						meta: {
							id: 0,
							activeName: 'datacenter',
							timeStamp: Math.random(),
							toolbarbutton: null,
							operatebutton: null,
							children: [],
						},
					})
				}
				// router.push({
				// 	no: 0,
				// 	path: '/main/cooperate/message/index',
				// 	name: '我的消息',
				// 	type: 'system',
				// 	component: () => import('@_system/views/main/cooperate/message/index.vue'),
				// 	meta: {
				// 		id: 0,
				// 		activeName: 'message',
				// 		timeStamp: Math.random(),
				// 		toolbarbutton: null,
				// 		operatebutton: null,
				// 		children: [],
				// 	},
				// })
				router.push({
					no: 0,
					path: '/main/cooperate/flowtemplate/index',
					name: '流程模板',
					type: 'system',
					component: () => import(
						'@_system/views/main/cooperate/flowtemplate/index.vue'),
					meta: {
						id: 0,
						activeName: 'flowtemplate',
						timeStamp: Math.random(),
						toolbarbutton: null,
						operatebutton: null,
						children: [],
					},
				})
				router.push({
					no: 0,
					path: '/main/cooperate/report/index',
					name: '报表',
					type: 'system',
					component: () => import('@_system/views/main/cooperate/report/index.vue'),
					meta: {
						id: 0,
						activeName: 'report',
						timeStamp: Math.random(),
						toolbarbutton: null,
						operatebutton: null,
						children: [],
					},
				})
				router.push({
					no: 0,
					path: '/components/phoneNav',
					name: '模块',
					type: 'system',
					component: () => import('@_system/components/phoneNav.vue'),
					meta: {
						id: 0,
						activeName: 'module',
						timeStamp: Math.random(),
						toolbarbutton: null,
						operatebutton: null,
						children: [],
					},
				})
				router.push({
					no: 0,
					path: '/main/cooperate/scan/index',
					name: '扫码',
					type: 'system',
					component: () => import(
						'@_system/views/main/cooperate/scan/index.vue'),
					meta: {
						id: 0,
						activeName: 'scan',
						timeStamp: Math.random(),
						toolbarbutton: null,
						operatebutton: null,
						children: [],
					},
				})
			} else {
				if (datacenter) {
					router.push({
						no: 0,
						path: '/main/datacenter/index',
						name: '数据概览',
						type: 'system',
						component: () => import('@_system/views/main/datacenter/index'),
						meta: {
							id: 0,
							timeStamp: Math.random(),
							toolbarbutton: null,
							operatebutton: null,
							children: [],
						},
					})
				}
				if (cooperate) {
					router.push({
						no: 0,
						path: '/main/cooperate/index',
						name: '协同中心',
						type: 'system',
						component: () => import('@_system/views/main/cooperate/index'),
						meta: {
							id: 0,
							timeStamp: Math.random(),
							toolbarbutton: null,
							operatebutton: null,
							children: [],
						},
					})
				}
			}

			return router
		},
	},
}